import { motion } from "framer-motion";
import { EASE } from "./Reveal";

const SRC = "/img/hero-pro.webp?v=6";
const SRC_MOBILE = "/img/hero-pro-mobile.webp?v=6";

export const ProImage = ({ className = "" }) => (
  <div className={`no-invert relative ${className}`}>
    <div className="pointer-events-none absolute left-1/2 top-[53%] h-[40%] w-[50%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/[0.05] blur-3xl lg:top-[66%]" aria-hidden="true" />
    <picture>
      <source media="(max-width: 1023px)" srcSet={SRC_MOBILE} />
      <motion.img
        data-testid="hero-pro-image"
        src={SRC}
        alt="iPhone 18 Pro"
        initial={{ opacity: 0, scale: 1.12 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.8, delay: 0.3, ease: EASE }}
        className="relative h-full w-full object-cover"
      />
    </picture>
  </div>
);
